import LocationPin from '../../src/legacy/LocationPin';
export default LocationPin;
